<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import type { HTMLAttributes } from "svelte/elements";
	import bagIcon from "@core/assets/icons/bag.svg?raw";
	import { Locale } from "@core/schema/Locale.js";
	import { makeInflect } from "@core/utils/makeInflect.js";
	import { Cart } from "../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./HeaderCartLink.translations.json" with { type: "json" };
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translations);

	const { tenant } = getGlobalTemplateProps();
	const productInflect = {
		[Locale.cs]: makeInflect("produkt", "produkty", "produktů"),
		[Locale.en]: makeInflect("product", "products", "products"),
	}[tenant.locale];

	const { transparentHeader, ...rest }: HTMLAttributes<HTMLButtonElement> & { transparentHeader: boolean } = $props();
	const cartCount = $derived(Cart.itemCount);
</script>

<button
	{...rest}
	class={[
		rest.class,
		"flex justify-center items-center gap-2.5 relative",
		"size-6 lg:h-12 xl:h-14 lg:w-auto lg:px-6 lg:py-4",
		"lg:border lg:rounded-full transition-colors",
		transparentHeader ? "border-white/16 hover:border-white" : "border-fcrlightgray hover:border-fcrgray",
	]}
	aria-label={translate("cartAria", { count: cartCount, product: productInflect(cartCount) })}
	aria-live="polite"
	onclick={(): void => {
		Cart.showModal = true;
	}}
>
	<Icon icon={bagIcon} class="size-6" />
	{#if cartCount > 0}
		<span
			aria-hidden="true"
			class={[
				"inline-flex justify-center rounded-full text-2.5/4 min-w-4 absolute top-px left-4 text-white bg-fcrdarkgray",
				"lg:min-w-0 lg:text-base  lg:static lg:bg-transparent",
				!transparentHeader && "lg:text-fcrgray",
			]}
		>
			{cartCount > 9 ? "9+" : cartCount}
		</span>
	{/if}
</button>
